<template>
  <div
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
  >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-on="on"
          v-bind="attrs"
        >
          <v-switch
            v-model="isActive"
            color="accent"
            hide-details
            @change="onSwitchToggle"
          >
            <template v-slot:label>
              <v-icon color="accent">{{ mdi }}</v-icon>
            </template>
          </v-switch>
        </div>
      </template>
      <span>{{ spantext }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    mdi1: {
      type: String
    },
    mdi2: {
      type: String
    },
    spantext: {
      type: String
    },
    value: {
      type: Boolean,
      defaut: true
    }
  },
  data() {
    return {
      isActive: this.value
    }
  },
  computed: {
    mdi() {
      return this.isActive ? this.mdi1 : this.mdi2
    }
  },
  methods: {
    onSwitchToggle(newValue) {
      this.$emit("switch", newValue)
    }
  }
}
</script>
